import { render } from "./Serm.vue?vue&type=template&id=82603d98&scoped=true"
import script from "./Serm.vue?vue&type=script&lang=js"
export * from "./Serm.vue?vue&type=script&lang=js"

import "./Serm.vue?vue&type=style&index=0&id=82603d98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82603d98"]])

export default __exports__